  <template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="extra-large"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("add_user") }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <form
        ref="form"
        data-url="/admin/auth/users"
        class="mb-sm-0"
        :class="{ 'loading-opacity': preloader }"
      >
        <div class="row">
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("first_name") }}
            </label>
            <app-input
              id="name"
              type="text"
              :required="true"
              v-model="inputs.first_name"
            />
          </div>
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("last_name") }}
            </label>
            <app-input
              id="name"
              type="text"
              :required="true"
              v-model="inputs.last_name"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <label for="text_input">
              {{ $t("email") }}
            </label>
            <app-input
              id="email"
              type="email"
              :required="true"
              v-model="inputs.email"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("phone") }}
            </label>
            <app-input
              id="phone"
              type="tel-input"
              :required="true"
              :placeholder="$t('type_contact_number')"
              v-model="inputs.phone"
            />
          </div>
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("role") }}
            </label>
            <app-input
              id="roles"
              class="col-sm-9"
              type="multi-select"
              :list="roleLists"
              list-value-field="name"
              :isAnimatedDropdown="true"
              v-model="inputs.roles"
              :required="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("password") }}
            </label>
            <app-input
              type="password"
              :required="true"
              :specialValidation="true"
              v-model="inputs.password"
            />
          </div>
          <div class="col-md-6">
            <label for="text_input">
              {{ $t("confirm_password") }}
            </label>
            <app-input
              type="password"
              v-model="inputs.confirm_password"
              same-as="inputs_password"
            />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <app-note
              note-type="note-warning"
              :show-title="false"
              :notes="[$t('password_hint_note')]"
            />
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <button
        type="submit"
        class="btn btn-primary mr-2"
        @click.prevent="submitData"
      >
        {{ $t("submit") }}
      </button>
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ROLES, USERS } from "../../../../Config/ApiUrl";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import { UserAndRoleMixin } from "../Mixins/UserAndRoleMixin";

export default {
  addurl: USERS,
  name: "mytaskmodal",
  mixins: [ModalMixin, FormMixin, UserAndRoleMixin],
  props: {
    userUrl: Object,
  },
  data() {
    return {
      modalId: "useraddmodal",
      inputs: {
        email: ' ',
        password: ' ',
      },
      roleLists: [],
    };
  },
  methods: {
    submitData() {
      if (this.inputs.date)
          this.inputs.date = this.getDateFormatForBackend(this.inputs.date);
          this.inputs.company_id = this.userRole.company_id;
      // axiosPost(USERS, this.inputs)
      //   .then((res) => {
      //     this.$toastr.s(res.data.message);
      //     this.$hub.$emit("reload-" + this.tableId);
      //   })
      //   .catch((error) => {
      //     this.$toastr.e(error.message);
          
      //   })
      //   .finally(() => {
      //     $("#useraddmodal").modal("hide");
      //     this.reLoadTable();
      //     this.preloader = false;
      //   });
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },
    getRoles() {
      this.preloader = this.hasData ? true : false;

      this.axiosGet(ROLES)
        .then((response) => {
          this.roleLists = response.data.data;
        })
        .catch(({ response }) => {})
        .finally(() => {
          this.preloader = false;
        });
    },
  },
  mounted() {
    this.getRoles();
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
